import { render, staticRenderFns } from "./ChannelSelector.vue?vue&type=template&id=504c02cc&scoped=true&"
import script from "./ChannelSelector.vue?vue&type=script&lang=js&"
export * from "./ChannelSelector.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSelector.vue?vue&type=style&index=0&id=504c02cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c02cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504c02cc')) {
      api.createRecord('504c02cc', component.options)
    } else {
      api.reload('504c02cc', component.options)
    }
    module.hot.accept("./ChannelSelector.vue?vue&type=template&id=504c02cc&scoped=true&", function () {
      api.rerender('504c02cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ChannelSelector.vue"
export default component.exports